/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';
import PropTypes from 'prop-types';

import { Image, Flex } from '@adobe/react-spectrum';

const ThumbnailCell = props => {
    const { children, thumbnail, thumbnailAlt } = props;

    if (!thumbnail) {
        return <>{children}</>;
    }

    return (
        <Flex alignItems="center" gap="size-100">
            <Image src={thumbnail} alt={thumbnailAlt} objectFit="contain" height="30px" width="30px" flexShrink={0} />
            {children}
        </Flex>
    );
};

ThumbnailCell.propTypes = {
    thumbnail: PropTypes.string,
    thumbnailAlt: PropTypes.string
};

export default ThumbnailCell;
